import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";

// components
import Loader from "../../../components/Loader/Index";
import ScheduleInternalTxnMultiApprovalCards from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnMultiApprovalCards";

// import ScheduleInternalTxnFilterSidebar from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnFilterSidebar/index.jsx";
import PaginationComponent from "../../../components/_utils/PaginationComponent";

import InternalAccDetailsPopUp from "../../../components/Accounts/InternalAccDetailPopup/index.jsx";
import ScheduleInternalTxnDetailPopup from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnDetailPopup/index.jsx";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat.js";

// New UI Components
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";

//import from redux
import { scheduleInternalTxnView } from "../../../redux/features/scheduleInternalTxn/index.js";

import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import {
  beneBankLookUp,
  beneCategories,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { ViewAllAccountInternal } from "../../../redux/features/InternalAccount/ViewAllAccountInternal.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN.js";

import ApprovalTopNavComponent from "../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";
import ICONS from "../../../assets/Icons/index.js";

const ScheduleInternalTransactionMultiSelect = () => {
  //Refs ---------------
  const sidebarButtonRef = useRef(null);
  const filterRef = useRef(null);
  const viewModalRef = useRef(null);
  const FrequencyRef = useRef(null);
  const settlementDropdownRef = useRef(null);
  const categoryDropdownRef = useRef(null);
  const paymentDropdownRef = useRef(null);
  const confidentialDropdownRef = useRef(null);
  const StartdateRef = useRef(null);
  const EnddateRef = useRef(null);
  const scrollRef = useRef(null);
  const searchBarContainer = useRef(null);
  const searchBarRef = useRef(null);

  //state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedPageValue, setSelectedPageValue] = useState(50);
  const [transactionData, setTransactionData] = useState([]);
  const [scheduleIntTxnLoading, setscheduleIntTxnLoading] = useState(false);
  const [formatedData, setFormatedData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [accountModalSearch, setAccountModalSearch] = useState(false);
  const [internalAccId, setInternalAccId] = useState("");
  const [internalScheduleId, setInternalScheduleId] = useState("");
  const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState("");
  const [internalAccDetailPopOpen, setInternalAccDetailPopOpen] =
    useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [searchdata, SetsearchData] = useState("");
  const [initCategoryFilter, setInitCategoryFilter] = useState("");
  const [internalAccNoValue, setInternalAccNoValue] = useState("");

  //filters states
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [filterPayload, setFilterPayload] = useState({
    pagination: 0,
    accNoInput: "",
    currentPage: 1,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    beneAccountSearch: "",
    searchTerm: "",
  });

  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [isFrequency, setisFrequency] = useState(false);
  const [isDropdownPaymentOpen, setDropdownPaymentOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showSecondContent, setShowSecondContent] = useState(false);
  const [showDatePicker1, setShowDatePicker1] = useState(false);
  const [isDropdownConfidentialOpen, setIsDropdownConfidentialOpen] =
    useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [IFSC, setIFSC] = useState("");
  const [bankLogo, setBankLogo] = useState("");
  const [amountInWords, setAmountInWords] = useState("");
  const [category, setCategory] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [panNumber, setPanNumber] = useState(null);
  const [IFSC1, setIFSC1] = useState("");
  const [bankLogo1, setBankLogo1] = useState("");
  const [beneAccountId, setBeneAccountId] = useState(null);

  const [FrequencyMethod, setFrequencyMethod] = useState("");
  const [frequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [confidentialMethod, setConfidentialMethod] = useState("");
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [txnAmount, setTxnAccount] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [ownerAccId, setOwnerAccId] = useState("");
  const [ownerAccNo, setOwnerAccNo] = useState("");
  const [internalAccNo, setInternalAccNo] = useState("");
  const [internalAccIdFilter, setInternalAccIdFilter] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  //selectors
  const { schedulesInternalTxnViewAllLoading } = useSelector(
    (state) => state.scheduleInternalTxnSlice,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  // variables
  const navigate = useNavigate();
  const dispatch = useDispatch();

  dispatch(setHideBreadCrumb({ hide: false }));

  const approvedAccounts =
    formatedData?.filter(
      (item) => item?.internal_account_approval_status === "approved",
    ) || [];

  const allApprovedSelected = selectedCardIds?.length === 20;

  //functions ----------------------------------
  //format function
  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(2, "0");
    const month = String(date.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const beneTxnPrev = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -1024,
        behavior: "smooth",
      });
    }
    setShowSecondContent(!showSecondContent);
    setDisablePrev(true);
    setDisableNext(false);
  };

  const beneTxnNext = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 1024,
        behavior: "smooth",
      });
    }
    setShowSecondContent(!showSecondContent);
    setDisableNext(true);
    setDisablePrev(false);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Internal account":
          response = await dispatch(
            ViewAllAccountInternal({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
              approval_status: "approved",
              type: "internalAccount",
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
              })) || [];
          }
          break;
        case "Search":
          SetsearchData(searchUserTextDebounce);
          setLoadingData(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleStartDateChange = (date) => {
    setStartDateFilter(date);
  };

  const handleEndDateChange = (date) => {
    setEndDateFilter(date);
  };

  //thunk function
  const handleAction = async () => {
    try {
      setscheduleIntTxnLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: selectedPageValue,
        lifecycle_status: "pending",
      };

      if (searchdata && searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (frequencyMethodfilter && frequencyMethodfilter !== "") {
        queryParams.frequency = frequencyMethodfilter;
      }

      if (category && category !== null) {
        queryParams.category = category;
      }

      if (startDateFilter && startDateFilter !== "") {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter && endDateFilter !== "") {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (paymentMethodFilter && paymentMethodFilter !== "") {
        queryParams.payment_method = paymentMethodFilter;
      }
      if (confidentialMethodFilter && confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (txnAmountFilter && txnAmountFilter > 0) {
        queryParams.amount = txnAmountFilter;
      }

      if (internalAccIdFilter && internalAccIdFilter !== "") {
        queryParams.internal_account_id = internalAccIdFilter;
      }

      if (ownerAccId && ownerAccId !== "") {
        queryParams.owner_account_id = ownerAccId;
      }

      const response = await dispatch(
        scheduleInternalTxnView(
          queryParams,
          // services,
        ),
      );
      const newData = response?.payload?.transactions || [];

      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTransactionData(response?.payload);
      setFormatedData(formattedData);

      setTotalCount(response?.payload?.total_count || 0);
    } catch (error) {
      console.error("Error in API call:", error);
      setTransactionData([]);
      setFormatedData([]);
    } finally {
      setscheduleIntTxnLoading(false);
    }
  };

  const onMount = () => {
    (async () => {
      await handleAction();
    })();
  };

  const handleSelectAllCard = () => {
    const alreadySelected = selectedCardIds || [];
    const remainingSelections = 20 - alreadySelected.length;

    // Attempt to add up to 20 approved accounts
    if (
      remainingSelections > 0 &&
      remainingSelections <= 20 &&
      ((alreadySelected.length !== approvedAccounts.length &&
        alreadySelected.length >= 0 &&
        approvedAccounts.length >= 0) ||
        (alreadySelected.length === 0 && approvedAccounts.length > 0))
    ) {
      const unselectedApproved = approvedAccounts.filter(
        (account) => !alreadySelected.includes(account.txn_id),
      );

      let newSelections;
      if (approvedAccounts.length > 20) {
        newSelections = unselectedApproved.slice(0, remainingSelections);
      } else {
        newSelections = unselectedApproved;
      }
      const newTxnIds = newSelections.map((account) => account.txn_id);

      setSelectedCardIds((prev) => [...prev, ...newTxnIds]);
      setSelectedSendTransactions((prev) => [...prev, ...newSelections]);
    } else {
      // No room to add more — deselect approved accounts
      const approvedTxnIds = approvedAccounts.map((item) => item.txn_id);

      const updatedSelectedIds = alreadySelected.filter(
        (id) => !approvedTxnIds.includes(id),
      );

      const updatedSendTransactions = selectedSendTransactions.filter(
        (txn) => !approvedTxnIds.includes(txn.txn_id),
      );

      setSelectedCardIds(updatedSelectedIds);
      setSelectedSendTransactions(updatedSendTransactions);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailPopOpen(!internalAccDetailPopOpen);
  };

  const closeScheduleInternalTxnModal = () => {
    setIsAdditionalPopupOpen("");
  };

  const handleChangePageSize = (value) => {
    setSelectedPageValue(value);
    setCurrentPage(1 || currentPage);
  };

  const toggleSideBar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    setFrequencyMethodfilter(selectedSettlement);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setPaymentMethodFilter(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleTxnAmmountMethod = (selectedSettlement) => {
    setTxnAmountFilter(selectedSettlement);
  };

  const handleStartDateMethod = (selectedSettlement) => {
    setStartDateFilter(selectedSettlement);
  };

  const handleEndDateMethod = (selectedSettlement) => {
    setEndDateFilter(selectedSettlement);
  };

  const handleAccountNameMethod = (selectedSettlement) => {
    setOwnerAccNo(selectedSettlement);
  };

  const handleAccountIdMethod = (selectedSettlement) => {
    setOwnerAccId(selectedSettlement);
  };

  const handleDestinationIdMethod = (selectedSettlement) => {
    setInternalAccIdFilter(selectedSettlement);
  };

  const handleDestinationNameMethod = (selectedSettlement) => {
    setInternalAccNo(selectedSettlement);
  };

  const handleClearParams = () => {
    setPaymentMethodFilter("");
    setPaymentMethod("");
    setFrequencyMethodfilter("");
    setFrequencyMethod("");
    setConfidentialMethodFilter("");
    setConfidentialMethod("");
    setOwnerAccNo("");
    setOwnerAccId("");
    setInternalAccNo("");
    setInternalAccIdFilter("");
    setStartDateFilter("");
    setStartDate("");
    setEndDateFilter("");
    setEndDate("");
    setTxnAmountFilter("");

    setTxnPayLoad({
      ...txnPayLoad,
      ownerAccountId: "",
      ownerbankAccountNo: "",
      beneAccountId: "",
      bankAccountNo: "",
      amount: "",
    });
    setOwnerAccNo("");
    setOwnerAccId("");
    setInternalAccNo("");
    setInternalAccIdFilter("");
    setStartDateFilter("");
    setStartDate("");
    setEndDateFilter("");
    setEndDate("");
    setTxnAmountFilter("");
    setInitCategoryFilter("");
    setSearchUserTextDebounce("");
    SetsearchData("");
    setInternalAccNoValue("");
  };

  //useEffects

  useEffect(() => {
    dispatch(enableSwitcher());
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      dispatch(disableSwitcher());
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    onMount();

    setIsFilterApplied(
      !(
        paymentMethodFilter === "" &&
        frequencyMethodfilter === "" &&
        confidentialMethodFilter === "" &&
        ownerAccNo === "" &&
        internalAccNo === "" &&
        startDateFilter === "" &&
        endDateFilter === "" &&
        txnAmountFilter === "" &&
        searchdata === "" &&
        initCategoryFilter === ""
      ),
    );
  }, [
    markerData,
    dispatch,
    selectedPageValue,
    currentPage,
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
  ]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
  ]);

  return (
    <>
      {internalAccDetailPopOpen && internalAccId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccDetailsPopUp
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccId}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      {isAdditionalPopupOpen !== "" && internalScheduleId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleInternalTxnDetailPopup
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            schedule_internaltxn_id={internalScheduleId}
            detailSelected={isAdditionalPopupOpen}
            typeMulti="MultiApprovalSelect"
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      <div
        className={` bg-primary-bg flex flex-col h-screen relative overflow-hidden`}
        style={{
          background: showInnerSearchBar ? "var(--bg-PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative z-z-index-content flex flex-col overflow-y-hidden overflow-x-hidden">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <div className="relative z-z-index-overlay">
              <ApprovalTopNavComponent
                ispagination={
                  formatedData?.length <= GlobalConfiguration.lengthCheckZero
                    ? false
                    : true
                }
                handleBack={() => navigate(-1)}
                isSelectionView={true}
                selectionText={`Transactions selected : ${selectedCardIds.length}`}
                selectionBtnProps={{
                  btnText: "Select up to 20",
                  btnType: "button",
                  enabledBgColor:
                    selectedCardIds?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedCardIds.includes(itm.txn_id),
                    )
                      ? "var(--positive-bg)"
                      : selectedCardIds?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",

                  hoverOption:
                    selectedCardIds?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedCardIds.includes(itm.txn_id),
                    )
                      ? "black"
                      : selectedCardIds?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "black"
                        : "white",
                  enabledTextColor: "var(--text-primary)",
                  icon:
                    selectedCardIds?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedCardIds.includes(itm.txn_id),
                    )
                      ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                      : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                  handleFunction: () => {
                    handleSelectAllCard();
                  },
                }}
                topNavCtaBtn2Props={{
                  inActiveVariantNeeded: true,
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedCardIds?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                  handleFunction: () => {
                    if (
                      selectedCardIds?.length >
                      GlobalConfiguration?.lengthCheckZero
                    ) {
                      sessionStorage.setItem(
                        "intSelectedScheduleCard",
                        JSON.stringify([
                          {
                            selectedDetails: selectedSendTransactions,
                            selectedIds: selectedCardIds,
                          },
                        ]),
                      );

                      navigate(
                        "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval",
                      );
                    }
                  },
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/internal_transaction_dashboard/schedule_single_approval",
                    ),
                }}
                iconComponentArray={[
                  {
                    icon: "https://q2pay.in/new_assets/common/view_all/search_white.svg",
                    title: "Search",
                    hoverOption: "white",
                    isLoading: false,
                    isDisabled: scheduleIntTxnLoading,
                    enabledBgColor:
                      isSidebarOpen ||
                      paymentMethodFilter?.length ||
                      frequencyMethodfilter?.length ||
                      confidentialMethodFilter?.length ||
                      startDateFilter ||
                      endDateFilter ||
                      searchdata?.length ||
                      txnAmountFilter
                        ? "var(--text-primary)"
                        : "var(--primary-bg)",
                    handleFunction: () => setShowSearchBar((prev) => !prev),
                  },
                ]}
                filteredSearchProps={{
                  setShowInnerSearchBar,
                  showSearchBar,
                  isSearchDisabled: scheduleIntTxnLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search schedule transaction",
                  filterPlaceholder: "schedule name",

                  filterItems: [
                    {
                      name: "Search",
                      isMulti: false,
                      value: searchdata,
                      setValue: SetsearchData,
                      isDropdown: false,
                      isDisabled: loading,
                    },
                    {
                      name: "Internal account",
                      short_name: "Int. Acc",
                      isMulti: false,
                      value: internalAccIdFilter,
                      displayValue: internalAccNo || internalAccNoValue,
                      setValue: setInternalAccIdFilter,
                      setDisplayValue: (val) => {
                        setInternalAccNo(val);
                        setInternalAccNoValue(val);
                      },
                      isDropdown: true,
                      valueType: "string",
                      isDisabled: scheduleIntTxnLoading,
                    },
                    {
                      name: "Owner account",
                      short_name: "Src. Acc",
                      isMulti: false,
                      value: ownerAccId,
                      displayValue: standardAccountNumberFormat(
                        ownerAccNo,
                        true,
                      ),
                      setValue: setOwnerAccId,
                      setDisplayValue: setOwnerAccNo,
                      valueType: "string",
                      isDropdown: true,
                      isDisabled: scheduleIntTxnLoading,
                    },

                    {
                      name: "Amount",
                      short_name: "Amt - INR",
                      isMulti: false,
                      value: txnAmountFilter,
                      setValue: setTxnAmountFilter,
                      displayValue: FormatAmount({ price: txnAmountFilter }),
                      isDropdown: false,
                      valueType: "number",
                      isDisabled: scheduleIntTxnLoading,
                    },
                  ],

                  filters: [
                    {
                      name: "Payment method",
                      filterType: "dropdown",
                      variant: "single",
                      options: ["NEFT", "RTGS", "IMPS", "FT"],
                      value: paymentMethodFilter,
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Select type",
                      handleChange: (val) => handlePaymentMethod(val),
                    },

                    {
                      name: "Schedule start date",
                      filterType: "calender",
                      variant: "single",
                      size: "small",
                      value: startDateFilter,
                      isDisable: false,
                      startDate: startDateFilter,
                      handleChange: (date) => handleStartDateChange(date),
                    },
                    {
                      name: "Schedule end date",
                      filterType: "calender",
                      variant: "single",
                      value: endDateFilter,
                      isDisable: false,
                      startDate: endDateFilter,
                      handleChange: (date) => handleEndDateChange(date),
                    },
                    {
                      name: "Frequency",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: [
                        "Once",
                        "Daily",
                        "Weekly",
                        "Fortnightly",
                        "Monthly",
                        "Quarterly",
                        "Half yearly",
                        "Yearly",
                      ],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Select frequency",
                      value: frequencyMethodfilter,
                      isDisable: false,
                      handleChange: (val) => handleFrequencyMethod(val),
                    },
                    {
                      name: "Show/hide confidential transactions",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["Show only confidential", "Hide confidential"],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Default (all transactions)",
                      value: confidentialMethodFilter,
                      handleChange: (val) => handleConfidentialMethod(val),
                    },
                  ],
                  isFilterClearAllDisabled: !(
                    paymentMethodFilter?.length ||
                    frequencyMethodfilter?.length ||
                    confidentialMethodFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    scheduleIntTxnLoading
                  ),

                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length ||
                    searchdata?.length ||
                    frequencyMethodfilter?.length ||
                    internalAccIdFilter?.length ||
                    ownerAccId?.length ||
                    paymentMethodFilter?.length ||
                    txnAmountFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    scheduleIntTxnLoading
                  ),

                  inputData,
                  active,
                  setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: true,
                }}
              />
            </div>

            <div
              ref={filterRef}
              className={`flex flex-col flex-1 overflow-y-auto
              ${
                formatedData?.length == GlobalConfiguration.lengthCheckZero ||
                scheduleIntTxnLoading ||
                schedulesInternalTxnViewAllLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              <div
                className="w-width-full  overflow-y-auto  h-[-webkit-fill-available] z-z-index-content"
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
              >
                {scheduleIntTxnLoading || schedulesInternalTxnViewAllLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !formatedData?.length ? (
                  <div
                    className="int-txn-mutli-no-account-found"
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--light-opacity)"
                        : "var(--base-opacity)",
                    }}
                  >
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? ICONS?.NO_DATA_FOUND
                            : ICONS?.NO_PENDING_TRANSACTION
                        }
                        className="px-padding-sm w-graphic-width-md h-graphic-square-height-md int_txn_img"
                        alt="NoData"
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account !mt-margin-sm">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear Parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Internal transaction dashboard"
                              handleFunction={() =>
                                navigate("/internal_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col items-center justify-center mx-auto bg-primary-bg"}`}
                    style={{
                      scrollPaddingTop: "20px",
                      scrollPaddingBottom: "20px",
                    }}
                  >
                    {/* Render Cards Grid */}
                    <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
                      {formatedData?.map((data, index) => {
                        return (
                          <React.Fragment key={data?.txn_id || index}>
                            <ScheduleInternalTxnMultiApprovalCards
                              data={data}
                              isSidebarOpenpop={showInnerSearchBar}
                              selectedCardIds={selectedCardIds}
                              setSelectedCardIds={setSelectedCardIds}
                              selectedSendTransactions={
                                selectedSendTransactions
                              }
                              setSelectedSendTransactions={
                                setSelectedSendTransactions
                              }
                              setIsAdditionalPopupOpen={
                                setIsAdditionalPopupOpen
                              }
                              setInternalAccDetailPopOpen={
                                setInternalAccDetailPopOpen
                              }
                              setInternalScheduleId={setInternalScheduleId}
                              setInternalAccId={setInternalAccId}
                            />
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Footer Section (Pagination & Mob Next Button) */}
            <div
              className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none" : "opacity-base-opacity"}`}
            >
              {(formatedData?.length ?? 0) !== 0 && !scheduleIntTxnLoading ? (
                <div className="z-z-index-fixed-ui w-screen">
                  <PaginationComponent
                    handleSelect={handleChangePageSize}
                    selectedValue={selectedPageValue}
                    data={transactionData}
                    pageSize={selectedPageValue}
                    dropdownOptions={[50, 100]}
                    handlePagination={handlePageChange}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleInternalTransactionMultiSelect;
